/**
 * Part of datavideo project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

popup($('.video-popup a'));
$('.c-feature-icon a').each((i, a) => {
  if ($(a).find('.fa-circle-play').length) {
    popup($(a));
  }
})

function popup($ele) {
  $ele.magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    iframe: {
        patterns: {
          youku: {
            index: 'v.youku.com',

            id: function(url) {
               var regex = url.match(/id_(\w+)/);
               if (regex !== null) {

                   return regex[1];
               }
               return null;
            },

             src: 'https://player.youku.com/embed/%id%'

          },
          QQ: {
            index: 'v.qq.com',

            id: function(url) {
               var regex = url.match(/https?:\/\/v\.qq\.com\/x\/page\/(.+)\.html/);
               if (regex !== null) {

                   return regex[1];
               }
               return null;
            },

             src: 'https://v.qq.com/txp/iframe/player.html?vid=%id%'

          },
        }
      }
  });
}
